import React from 'react';
import {
    Grid,
    Table,
    TableContainer,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Paper,
    Typography,
    Accordion,
    AccordionSummary,
    AccordionDetails,
} from '@material-ui/core';
import {makeStyles, withStyles} from '@material-ui/core/styles';
import {toSnakeCase} from 'components/forms/locale/utils';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const useStyles = makeStyles(theme => ({
    fieldLabel: {
        fontWeight: 'bold',
        marginBottom: '0em',
    },

    tableHeader: {
        background: theme.palette.background.default,
        color: theme.palette.text.primary,
    },
    tableHeaderCell: {
        fontWeight: 'bold',
    },
}));

const StyledTableRow = withStyles(theme => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor:
                theme.palette.type === 'dark'
                    ? theme.palette.gray.light2
                    : theme.palette.primary.light4,
        },
        '&:hover': {
            backgroundColor:
                theme.palette.type === 'dark'
                    ? theme.palette.primary.light
                    : theme.palette.primary.light3,
            cursor: 'pointer',
        },
        '& td a': {
            textDecoration: 'none',
        },
    },
}))(TableRow);

const MyAccordionSummary = withStyles({
    root: {
        borderBottom: '0px',
        margin: '0px',
        paddingTop: '.2rem',
        minHeight: 12,
        '&$expanded': {
            minHeight: 12,
        },
    },
    content: {
        marginBottom: '0px',
        marginTop: '0.2rem',
        '&$expanded': {
            margin: '0',
        },
    },

    expanded: {},
})(AccordionSummary);

const MyAccordionDetails = withStyles(theme => ({
    root: {
        padding: 0,
    },
}))(AccordionDetails);

const MyAccordion = withStyles({
    root: {
        boxShadow: 'none',
        '&:not(:last-child)': {
            borderBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
    },
    expanded: {},
})(Accordion);

const MMCdomestic = ({mmld, noheader, admin}) => {
    const classes = useStyles();
    const mmc =
        mmld?.user_endorsements ||
        mmld?.mmld_docs.filter(doc => doc.DOCUMENT_TYPE === 'MMC') ||
        [];

    if (mmc.filter(mmcType => mmcType.CAPACITY_TYPE_CD === 'D').length) {
        if (noheader) {
            return (
                <Grid container className={classes.root} direction='column'>
                    <Grid item>
                        <TableContainer component={Paper}>
                            <Table aria-label='MMC table' className={classes.table}>
                                <TableHead className={classes.tableHeader}>
                                    <TableRow>
                                        <TableCell
                                            className={classes.tableHeaderCell}
                                        >
                                            Capacity
                                        </TableCell>
                                        <TableCell
                                            className={classes.tableHeaderCell}
                                        >
                                            Limitations
                                        </TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {mmc
                                        ?.filter(
                                            mmcType =>
                                                mmcType.CAPACITY_TYPE_CD === 'D'
                                        )
                                        ?.map((mmc, i) => (
                                            <StyledTableRow
                                                key={`${toSnakeCase(
                                                    mmc.user_capacity_desc
                                                )}-${i}`}
                                            >
                                                <TableCell>
                                                    {mmc.user_capacity_desc}
                                                </TableCell>
                                                <TableCell>
                                                    {mmc.user_limitation}
                                                </TableCell>
                                            </StyledTableRow>
                                        ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                </Grid>
            );
        } else {
            return (
                <MyAccordion defaultExpanded>
                    <MyAccordionSummary
                        className={classes.summary}
                        expandIcon={<ExpandMoreIcon />}
                    >
                        <Typography variant='h6'>
                            Your Domestic Capacities
                        </Typography>
                    </MyAccordionSummary>
                    <MyAccordionDetails>
                        <Grid container className={classes.root} direction='column'>
                            <Grid item>
                                <TableContainer component={Paper}>
                                    <Table
                                        aria-label='MMC table'
                                        className={classes.table}
                                    >
                                        <TableHead className={classes.tableHeader}>
                                            <TableRow>
                                                <TableCell
                                                    className={
                                                        classes.tableHeaderCell
                                                    }
                                                >
                                                    Capacity
                                                </TableCell>
                                                <TableCell
                                                    className={
                                                        classes.tableHeaderCell
                                                    }
                                                >
                                                    Limitations
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {mmc
                                                ?.filter(
                                                    mmcType =>
                                                        mmcType.CAPACITY_TYPE_CD ===
                                                        'D'
                                                )
                                                ?.map(mmc => (
                                                    <StyledTableRow
                                                        key={toSnakeCase(
                                                            mmc.user_capacity_desc ||
                                                                mmc.endorsement_name
                                                        )}
                                                    >
                                                        <TableCell>
                                                            {mmc.user_capacity_desc ||
                                                                mmc.endorsement_name}
                                                        </TableCell>
                                                        <TableCell>
                                                            {mmc.user_limitation}
                                                        </TableCell>
                                                    </StyledTableRow>
                                                ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>
                        </Grid>
                    </MyAccordionDetails>
                </MyAccordion>
            );
        }
    } else {
        return <div></div>;
    }
};

export default MMCdomestic;
